var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployee3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#5D61E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5294 20.1C10.5294 19.1387 10.744 18.28 11.1734 17.524C11.612 16.7587 12.2047 16.166 12.9514 15.746C13.7074 15.3167 14.552 15.102 15.4854 15.102C16.5774 15.102 17.534 15.382 18.3554 15.942C19.1767 16.502 19.7507 17.2767 20.0774 18.266H17.8234C17.5994 17.7993 17.282 17.4493 16.8714 17.216C16.47 16.9827 16.0034 16.866 15.4714 16.866C14.902 16.866 14.3934 17.0013 13.9454 17.272C13.5067 17.5333 13.1614 17.9067 12.9094 18.392C12.6667 18.8773 12.5454 19.4467 12.5454 20.1C12.5454 20.744 12.6667 21.3133 12.9094 21.808C13.1614 22.2933 13.5067 22.6713 13.9454 22.942C14.3934 23.2033 14.902 23.334 15.4714 23.334C16.0034 23.334 16.47 23.2173 16.8714 22.984C17.282 22.7413 17.5994 22.3867 17.8234 21.92H20.0774C19.7507 22.9187 19.1767 23.698 18.3554 24.258C17.5434 24.8087 16.5867 25.084 15.4854 25.084C14.552 25.084 13.7074 24.874 12.9514 24.454C12.2047 24.0247 11.612 23.432 11.1734 22.676C10.744 21.92 10.5294 21.0613 10.5294 20.1ZM29.9975 15.228V25H28.0375V20.842H23.8515V25H21.8915V15.228H23.8515V19.246H28.0375V15.228H29.9975Z",
    fill: "#5D61E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee3);
export default __webpack_public_path__ + "static/media/employee3.37b50b9a8b0ddf8e20bab72af47b195e.svg";
export { ForwardRef as ReactComponent };